import { FC } from 'react';

import { useLogout } from 'app/api/hooks/core/v1/auth/user';

// Local Typings
export type ContextScope = 'payee' | 'payor';
interface ChildrenProps {
  onLogout: () => void;
}
interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: (props: ChildrenProps) => React.ReactElement<any>;
  contextScope?: ContextScope;
}

// Component Definition
const Logout: FC<Props> = props => {
  const { mutate: logout } = useLogout();

  function handleLogout() {
    logout(undefined);
  }

  return props.children({ onLogout: handleLogout });
};

export default Logout;
